import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import EmptyCart from 'assets/icons/bag-cross.svg?url';

import classes from './CartEmpty.module.scss';

const CartEmpty = () => {
	return (
		<div
			className={`${classes['empty-cart-wrapper']} d-flex flex-column align-items-center justify-content-center my-5`}>
			<img src={EmptyCart} alt="empty-cart" className="my-3" />
			<h5 className="my-1">Your cart is empty!</h5>
			<p>Looks like you haven’t made your choice yet.</p>
			<LinkButton kind="simple" to="/" className="my-4">
				GO to Homepage
			</LinkButton>
		</div>
	);
};

export default CartEmpty;
